
      import ShoppingBag from './shopping-bag.vue'
      import type { App, Plugin } from 'vue'

      export const ShoppingBagPlugin: Plugin = {
        install(app: App) {
          app.component('ShoppingBag', ShoppingBag)
        },
      }
      export { ShoppingBag }
      